import React from "react";
import { DrawerContext } from "./DrawerContext";
// drawerContext={drawer}
/**HoC for handling the Drawer context to be used for class components */
const withDrawerWrapper = (Component: any) => (props: any) => (
  <DrawerContext.Consumer>
    {(drawer) => (
      <Component
        {...props}
        openDrawer={drawer?.openDrawer}
        closeDrawer={drawer?.closeDrawer}
      />
    )}
  </DrawerContext.Consumer>
);

export default withDrawerWrapper;
